import axios from "axios";

const baseURL = process.env.VUE_APP_MESSENGER_API || "https://proship-messenger.fly.dev";

// Pages that dropped off proship-messenger: buyers get no tracking number from them.
// Plain axios on purpose (like botPages): no interceptor, so a 401 never logs the seller out.
export default {
  namespaced: true,
  state: {
    disconnected: [],
    count: 0,
    loaded: false
  },
  getters: {
    count: state => state.count,
    names(state) {
      const list = state.disconnected.map(p => p.name || p.pageId);
      let text = list.slice(0, 3).join(", ");
      if (state.count > 3) text += " และอีก " + (state.count - 3) + " เพจ";
      return text;
    }
  },
  mutations: {
    set(state, { disconnected, count }) {
      state.disconnected = disconnected;
      state.count = count;
      state.loaded = true;
    },
    clear(state) {
      state.disconnected = [];
      state.count = 0;
      state.loaded = true;
    }
  },
  actions: {
    fetch({ commit, rootState }) {
      const auth = rootState.user && rootState.user.authData;
      if (!auth || !auth.token) return Promise.resolve();
      return axios
        .get(baseURL + "/api/pages/status", {
          headers: { Authorization: "Bearer " + auth.token },
          timeout: 15000
        })
        .then(res => {
          const d = res.data;
          if (d && d.success && d.count > 0 && Array.isArray(d.disconnected)) {
            commit("set", { disconnected: d.disconnected, count: d.count });
          } else {
            commit("clear");
          }
        })
        .catch(() => commit("clear"));
    }
  }
};

